import { GlButton, GlLoadingIcon, GlSprintf, GlIcon, GlTooltipDirective } from '@gitlab/ui';
import EditorModeSwitcher from './editor_mode_switcher.vue';
export default {
    name: 'MarkdownToolbar',
    components: {
        GlButton,
        GlLoadingIcon,
        GlSprintf,
        GlIcon,
        EditorModeSwitcher
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        markdownDocsPath: {
            type: String,
            required: true
        },
        canAttachFile: {
            type: Boolean,
            required: false,
            default: true
        },
        showCommentToolBar: {
            type: Boolean,
            required: false,
            default: true
        },
        showContentEditorSwitcher: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'enable-content-editor'
    ],
    computed: {
        showEditorModeSwitcher () {
            return this.showContentEditorSwitcher;
        }
    }
};
